import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';
import ConversionListStatistics from './ConversionListStatistics';
import Statistics from './Statistics';
import DayStatistics from './DayStatistics';
import CompareTime from './CompareTime';
import CartStatistics from './CartStatistics';

const ConversionStatistics = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };
  // 테스트
  return (
    <MainTemplate>
      <MbTabs
        name="AbusingList"
        tabMenuList={tabList()}
        tabs={{
          //전환비교 (일자별)
          '/report/conversion/compareDaily': {
            tabComponent: <DayStatistics />,
          },
          //전환비교 (시간대)
          '/report/conversion/compareTime': {
            tabComponent: <CompareTime />,
          },
          // 컨버전 상세
          '/report/conversion/detail': {
            tabComponent: <Statistics />,
          },
          '/report/conversion/cartDetail': {
            tabComponent: <CartStatistics />,
          },
          // 컨버전 리스트 (팝업)
          '/report/conversion/state_list': {
            tabComponent: <ConversionListStatistics />,
            isPop: 1,
          },
        }}
      />
    </MainTemplate>
  );
};

export default ConversionStatistics;
